import React from 'react';
import PropTypes from 'prop-types';
import { bindUGCCatalogue, getUGCCatalogueItemSafe } from 'rp-bloodstock-search';
import ShortlistButton from '../../components/ShortlistButton/ShortlistButton';
import NoteButton from '../../components/NoteButton/NoteButton';
import HorseNameCell from '../../components/DataTable/HorseNameCell';

function HorseNameCellConnected({
                                    shortlist,
                                    note,
                                    isExpanded,
                                    ...props
                                }) {
    const content = <HorseNameCell {...props} />;

    if (isExpanded) return content;

    return (
        <div className="catalogueTable__horseCell">
            <div className="catalogueTable__horseCellContent">{content}</div>
            {shortlist && (
                <ShortlistButton
                    className="catalogueTable__horseCellIconButton"
                    highlighted
                />
            )}
            {note && (
                <NoteButton
                    className="catalogueTable__horseCellIconButton"
                    highlighted
                />
            )}
        </div>
    );
}

HorseNameCellConnected.propTypes = {
    isExpanded: PropTypes.bool,
    shortlist: PropTypes.bool,
    note: PropTypes.bool
};

function makeProps(catalogue, ownProps) {
    const {
        rowData: { venue_uid, sale_date_raw, lot_no, lot_letter },
        customCell: { options: { showShortlist, showNote } }
    } = ownProps;
    const { shortlist, note } = getUGCCatalogueItemSafe(
        catalogue,
        venue_uid,
        sale_date_raw,
        lot_no,
        lot_letter,
    );
    return {
        shortlist: showShortlist && shortlist,
        note: showNote && note,
    };
}

export default bindUGCCatalogue(HorseNameCellConnected, makeProps);



// WEBPACK FOOTER //
// ./src/js/components/DataTable/HorseNameCellConnected.js